import Page from '@core_modules/home/pages/default';

export default Page;
